module.exports = __webpack_public_path__ + "img/menu-News.7c4d21bc.svg";